import React from 'react';
import Button from '@mui/material/Button';
import { IconButton } from '@mui/material';
import { useUserAccess } from '@ui-framework/index';
import permissionConfig from '../../config/permissionConfig';

/**
 * PermissionButton - A wrapper around MUI Button that can be extended
 * to handle permission logic.
 *
 * Props:
 * - permission (optional): Boolean or function to determine if button is enabled
 * - children: Button content
 * - ...rest: Other MUI Button props
 */
function PermissionButton({ permissionName = null, children, ...rest }) {
  if (!permissionName) {
    throw Error('Permission Button requires a permission name');
  }
  const userAccess = useUserAccess();
  const hasPermission = permissionConfig({ userAccess, permissionName });

  if (!hasPermission) {
    return null;
  }

  return <Button {...rest}>{children}</Button>;
}

export function PermissionIconButton({
  permissionName = null,
  children,
  ...rest
}) {
  if (!permissionName) {
    throw Error('Permission Button requires a permission name');
  }
  const userAccess = useUserAccess();
  const hasPermission = permissionConfig({ userAccess, permissionName });

  if (!hasPermission) {
    return null;
  }

  return <IconButton {...rest}>{children}</IconButton>;
}

export default PermissionButton;
